import {TranslationCollection} from "../../../models/translation";

export interface UiState<T> {
    id: any;
    state: T;
}

export interface TranslationModel extends TranslationCollection {
    enterLocation: string;
    selectResellerHeader: string;
    mapTitle: string;
    mapText: string;
}

export interface ResellerOrderCheckoutModel {
    infoBlock: string;
    resellers: Reseller[];
    orderInfo: OrderInfo;
}

export interface Reseller {
    id: string;
    name: string;
    address: string;
    postalCode: number;
    latitude: number;
    longitude: number;
    city: string;
    distance: number;
    default: boolean;
}

export interface OrderInfo {
    products: Product[];
    bundles: Bundle[];
}

export interface Product {
    orderRowId: string;
    articleNumber: string;
    name: string;
    imageUrl: string;
    quantity: number;
    unit: string;
    itemPriceUnit: string;
}

export interface Bundle {
    id: string;
    name: string;
    products: Product[];
    virtualProducts: Product[];
}

export interface Position {
    lat: number;
    lng: number;
}

export const mapOptions = {
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: false,
    maxZoom: 17,
    mapTypeId: "roadmap"
};

